import { useContext, useEffect, useState } from "react"
import '../../style/components/attendance.css';
import { mainSearch, recodeNow } from '../indexDB/indexDBStora'
import { useDebounce } from '../../funcs/hooks/useDebounce';
import { switchh } from "../../context/switch";
import { CurrentTime } from "../../funcs/current";
import { action } from "../../context/action";
import {getDiffMinutes} from '../../funcs/getDiffMin'
import { Setting } from "../../context/settings";
import TableTody from "../global/tableToday";
import { CheckUserAtt } from "../../funcs/checkAtt";
import { collection } from "../../context/collect";
import { useTranslation } from "react-i18next";

export default function Attendance () {
    const { t } = useTranslation();
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [user,setUser] = useState([])
    const {setLoadingProcess, loadingProcess, setEnableAttendance} = useContext(switchh);
    const { storeBusniessRules } = useContext(Setting);
    const {setErrorMessage, errorMessage} = useContext(action);
    const { shift } = useContext(collection);

    const writeCode = useDebounce(code, 1000); 

    useEffect(()=> {
        if(!code) {
            setLoadingProcess(false);
            setName("")
            return
        };
        const getUser = async () => {
            const user = await mainSearch("employees", writeCode);
            setUser(user);
            if(!user) {
                setName("");
                setLoadingProcess(false)
                return;
            }
            setName(user.fullName)
            setLoadingProcess(false)
        }
        getUser()
    }, [writeCode])

    const handleAttendance = async () => {
    if (!code || !name) return;

    const today = CurrentTime(false, true);
    const preventRepeat = await CheckUserAtt(today, code);
    
    if(preventRepeat) {
        setErrorMessage("هذا المستخدم موجود اليوم فعليا");
        return;
    }
    
    const date = new Date();
    const holidays = user.shift;
    const time = CurrentTime(true, false);

    if(!holidays.holiday) {
        setErrorMessage("لا يوجد وقت للعمل لهذا لمستخدم يرجى اضافته من شئون العاملين");
        return;
    }

    // check holiday
    if (holidays.holiday.includes(String(date.getDay()))) {
        setErrorMessage("لا يمكن تسجيل هذا المستخدم لأن اليوم عطلة له");
        return;
    }
        
    setErrorMessage("")

    const diff = getDiffMinutes(time, holidays.shiftDates.start);

    if (diff >= storeBusniessRules.timeEmpWork.delay.min) {
        shift.action.deduction = storeBusniessRules.timeEmpWork.delay.deduction;

    } else if (diff <= storeBusniessRules.timeEmpWork.early.min) {
        shift.action.bouns = storeBusniessRules.timeEmpWork.early.bouns;
    }

    shift.code = user.code;
    shift.fullName = user.fullName;
    shift.job = user.job;
    shift.date.start = time;
    shift.today = today;

    await recodeNow(shift, "schedule");
    
    setCode("");
    setName("");
    };
    return (
        <div className="attendance-container container-box fixed flex flex-center-center">
            <div className="box">
                <button onClick={() => {
                    setErrorMessage("")
                    setEnableAttendance(false);
                }} className="close">X</button>
                <div className="flex attendace-parent">
                    <div className="atten">
                        <div>
                            <label>{t("label:Attendance.empCode")}</label>
                            <div className="flex parent">
                                <input onChange={(e) => {
                                    setCode(e.target.value);
                                    setLoadingProcess(true)
                                }} value={code} type="text" placeholder={t("placeholder:attendance.writeCode")} />
                                <button onClick={() => handleAttendance()} className="text-weight-bold">{t("action:attended")}</button>
                            </div>
                            <p>{loadingProcess && t("common:searching")}</p>
                        </div>
                        <input disabled value={name} placeholder={t("placeholder:attendance.EmpName")} />
                        <p className="error">{errorMessage}</p>
                    </div>
                    <TableTody />
                </div>
            </div>
        </div>
    )
}